var $7dbdd7289c10d2ba$exports = {};
$7dbdd7289c10d2ba$exports = {
    "close": `Zatvori`,
    "notifications": `Obave\u{161}tenja`
};


export {$7dbdd7289c10d2ba$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
